<template>
	<div class="center-left">
		<div class="center-left-title">我的账户</div>
		<div class="center-left-item flex-start flex-center" :class="menu==1?'active':''" @click="toUrl(1,'/centerindex')">
			<img v-if="menu == 1" src="@/assets/images/me/icon11.png"/>
			<img v-else src="@/assets/images/me/icon1.png"/>
			<div>个人中心</div>
		</div>
		<div class="center-left-item flex-start flex-center" :class="(menu==2 || menu==-2)?'active':''" @click="toUrl(2,'/usermessage')">
			<img v-if="(menu==2 || menu==-2)" src="@/assets/images/me/icon22.png"/>
			<img v-else src="@/assets/images/me/icon2.png"/>
			<div>消息通知</div>
		</div>
		<div class="center-left-item flex-start flex-center" :class="menu==4?'active':''" @click="toUrl(4,'/useraddress')">
			<img v-if="menu == 4" src="@/assets/images/me/icon44.png"/>
			<img v-else src="@/assets/images/me/icon4.png"/>
			<div>地址管理</div>
		</div>
		<div class="center-left-item flex-start flex-center" :class="(menu==5 || menu==-5)?'active':''" @click="toUrl(5,'/usersetting')">
			<img v-if="(menu==5 || menu==-5)" src="@/assets/images/me/icon5.png"/>
			<img v-else src="@/assets/images/me/icon5.png"/>
			<div>安全设置</div>
		</div>
		<div class="center-left-title">交易管理</div>
		<div class="center-left-item flex-start flex-center" :class="(menu == 6 || menu == -6)?'active':''" @click="toUrl(6,'/userorder')">
			<img v-if="menu == 6 || menu == -6" src="@/assets/images/me/icon66.png"/>
			<img v-else src="@/assets/images/me/icon6.png"/>
			<div>我的订单</div>
		</div>
		<div class="center-left-item flex-start flex-center" :class="menu==7?'active':''" @click="toUrl(7,'/usercoupon')">
			<img v-if="menu == 7" src="@/assets/images/me/icon77.png"/>
			<img v-else src="@/assets/images/me/icon7.png"/>
			<div>优惠券</div>
		</div>
		<div class="center-left-item flex-start flex-center" :class="(menu == 8 || menu == -8)?'active':''" @click="toUrl(8,'/userrefundlist')">
			<img v-if="menu == 8 || menu == -8" src="@/assets/images/me/icon88.png"/>
			<img v-else src="@/assets/images/me/icon8.png"/>
			<div>售后服务</div>
		</div>
		<div class="center-left-title">帮助中心</div>
		<div v-for="(item,index) in list" :key="item.id" class="center-left-item flex-start flex-center" :class="menu==item.id+9?'active':''" @click="toUrl(item.id+9,'/userquestion?id='+item.id)">
			<img v-if="menu == item.id+9" src="@/assets/images/me/icon99.png"/>
			<img v-else src="@/assets/images/me/icon9.png"/>
			<div>{{item.title}}</div>
		</div>
	</div>
</template>

<script>
	import {qaList} from "@/api/index"
	export default {
		props: {
			menu: {
				type: Number,
				value: 1
			}
		},
		data(){
			return {
				list:[]
			}
		},
		mounted() {
			qaList().then(res=>{
				if(res.code == 1000){
					this.list = res.data;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		methods:{
			toUrl(type, url){
				if(this.menu != type){
					this.$router.push(url);
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.center-left-item{
		border-left: 2px solid #fff;
		padding-left: 28px;
		height: 40px;
		line-height: 40px;
		margin-bottom: 10px;
		cursor: pointer;
		img{
			width: 20px;
			height: 20px;
			margin-right: 12px;
			flex: 0 0 20px;
		}
		div{
			font-size: 16px;
			line-height: 40px;
			color: #070B13;
		}
	}
	.active{
		background: rgba(233, 26, 18, 0.1);
		border-left: 2px solid rgba(233, 26, 18, 1);
		div{
			color: rgba(233, 26, 18, 1);
		}
	}
	.center-left-title{
		padding: 20px 30px;
		line-height: 28px;
		font-size: 20px;
		color: #070B13;
	}
	.center-left{
		width: 280px;
		flex: 0 0 280px;
		height: 920px;
	}
</style>